'use client';

import { createContext, ReactNode, useContext } from 'react';

export type Platform = 'app' | 'copilot';

const PlatformContext = createContext<Platform>('app');

export function PlatformProvider({
  platform,
  children,
}: {
  platform: Platform;
  children: ReactNode;
}) {
  return <PlatformContext.Provider value={platform}>{children}</PlatformContext.Provider>;
}

export function usePlatform(): Platform {
  return useContext(PlatformContext);
}
